// extracted by mini-css-extract-plugin
export default {"image":"ingredient-details_image__aB0dq","name":"ingredient-details_name__d5L0D","elements":"ingredient-details_elements__i0g5+"};